import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS } from '../const.config';

// manage categories module configurations
export const LISTING_COLUMNS = [
  {
    id: 'title',
    label: 'Category Name',
    width: '20%',
    align: 'left',
    dataKey: 'title',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'status',
    label: 'Status',
    width: '20%',
    align: 'left',
    dataKey: 'status',
    sortable: false,
    type: CELL_DATA_TYPES.BOOL,
  },
  {
    id: 'createdAt',
    label: 'Created Date',
    width: '15%',
    align: 'center',
    dataKey: 'createdAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'modifiedAt',
    label: 'Modified Date',
    width: '15%',
    align: 'center',
    dataKey: 'modifiedAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LISTING_ACTIONS = [
  {
    action: ACTIONS.DELETE.value,
    label: ACTIONS.DELETE.label,
  },
];
